import React from 'react'
import { createUrl } from '../../Routing/urls'
import { CURRENT_YEAR } from '../../Config/League/league.config'
import { RosterTableCon, PlayerNameCon } from './styles'
import { logEvent, concatCollege } from '../../Utils'
import { Injury } from '../../Pages/Player/components/Injury/Injury'
import { PlayerDataGQL } from '../../Api'
import { Img } from '../Image/Img'
import { AdUnit } from '../Ads/AdUnit'
import { ANALYTICS_TAGS } from '../../Constants/analytics'
import { TableHeader } from './TableHeader'

type TeamRosterProps = {
  roster: PlayerDataGQL[]
  rosterType?: 'Full' | 'Active' | 'Inactive' | 'Champ Series'
  theme?: 'light' | 'dark' | 'gray'
  eventId?: string
  location?: string
}

export const RosterTable: React.FC<React.PropsWithChildren<TeamRosterProps>> = ({
  roster,
  rosterType = 'Full',
  theme = 'light',
  eventId,
  location,
}) => {
  const rosterHeader = rosterType === 'Inactive' ? 'Inactives' : `${rosterType} Roster`

  return (
    <>
      {rosterType !== 'Champ Series' && <h2>{rosterHeader}</h2>}
      <RosterTableCon uiTheme={theme}>
        <thead>
          <tr>
            <TableHeader ariaLabel="Player">Player</TableHeader>
            <TableHeader ariaLabel="Position">Position</TableHeader>
            <TableHeader ariaLabel="Height">Height</TableHeader>
            <TableHeader ariaLabel="College">College</TableHeader>
          </tr>
        </thead>
        <tbody>
          {roster.map((plr, idx) => (
            <>
              <tr key={plr.slug}>
                <td>
                  <PlayerNameCon>
                    <a
                      href={createUrl('player', {
                        slugName: plr.slug,
                        tab: 'profile',
                        year: CURRENT_YEAR,
                      })}
                      aria-label={`${plr.firstName} ${plr.lastName} profile`}
                      onClick={() =>
                        logEvent(ANALYTICS_TAGS.player_roster_click, {
                          player: `${plr.firstName} ${plr.lastName}`,
                          team: plr.currentTeam?.fullName,
                          game: eventId,
                          location: location,
                        })
                      }
                    >
                      <Img
                        src={plr.profileUrl}
                        alt={`${plr.firstName} ${plr.lastName} profile`}
                      />
                      {`${plr?.jerseyNum !== null ? plr.jerseyNum : ''} ${
                        plr.firstName
                      } ${plr.lastName}`}
                    </a>
                    <Injury player={plr} />
                  </PlayerNameCon>
                </td>
                {rosterType === 'Champ Series' ? (
                  <td>{plr?.champSeries?.position}</td>
                ) : (
                  <td>{plr?.currentTeam?.position}</td>
                )}
                <td>{plr.height}</td>
                <td>
                  {plr?.college &&
                    concatCollege(plr.college, plr.collegeYear)}
                </td>
              </tr>
              {idx === 5 && <AdUnit bannerType="bannerSecond" aria-label="Roster table ad" />}
              {idx === 12 && <AdUnit bannerType="bannerThird" aria-label="Roster table ad" />}
            </>
          ))}
        </tbody>
      </RosterTableCon>
    </>
  )
}
